import React from 'react'
import { ArrowRight } from 'lucide-react'

export default function Cta() {
  return (
    <section className="py-16 relative overflow-hidden">
      {/* Background accents for desktop */}
      <div className="hidden md:block absolute -right-40 top-1/2 w-[350px] h-[350px] rounded-full bg-[#0B63F8] blur-3xl animate-pulse transform -translate-y-1/2" />
      <div className="hidden md:block absolute -left-40 top-1/2 w-[350px] h-[350px] rounded-full bg-[#0B63F8] blur-3xl animate-pulse transform -translate-y-1/2" />

      <div className="container mx-auto px-6">
        <div className="relative backdrop-blur-xl bg-gradient-to-br from-white/10 to-white/5 border-2 border-[#28E7C5]/20 rounded-2xl p-12 max-w-4xl mx-auto overflow-hidden shadow-[0_0_50px_rgba(40,231,197,0.1)] hover:shadow-[0_0_80px_rgba(40,231,197,0.2)] transition-all duration-500">
          <div className="relative z-10">
            <div className="text-center mb-8">
              {/* Headline */}
              <h2 className="text-2xl md:text-4xl font-bold mb-4 text-white">
                Precisa de uma Ferramenta Personalizada para seu escritório?
              </h2>
              {/* Subtitle */}
              <p className="text-base md:text-xl text-gray-300">
                Nós construímos o que você precisar com base nos seus modelos, dados e preferências!
              </p>
            </div>

            {/* Button */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="https://api.whatsapp.com/send?phone=5584999869794&text=Ol%C3%A1!%20Quero%20solicitar%20uma%20ferramenta%20personalizada!"
                target="_blank"
                rel="noopener noreferrer"
                className="group"
              >
                <button className="relative group px-8 py-3 md:px-12 md:py-5 bg-gradient-to-r from-orange-700 to-orange-800 text-white rounded-xl font-bold text-sm md:text-lg transition-all duration-500 hover:shadow-[0_0_30px_rgba(194,65,12,0.6)] hover:scale-105 flex items-center justify-center overflow-hidden">
                  Solicite agora
                  <ArrowRight className="ml-2 w-4 h-4 md:w-5 md:h-5 transition-transform group-hover:translate-x-1" />
                  
                  {/* Fade overlay - only visible from md breakpoint upwards */}
                  <div
                    className="hidden md:block absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent 
                               opacity-0 group-hover:opacity-100 
                               transform -translate-x-full skew-x-12 
                               group-hover:translate-x-full 
                               transition-transform duration-700 ease-in-out pointer-events-none"
                  />
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
